export const promoImage = require("./promo.png");
